interface EmptyDataProps {
  icon?: React.ReactNode;
  title: string;
  subtitle1: string;
}

export function EmptyData({ icon, title, subtitle1 }: EmptyDataProps) {
  return (
    <div>
      {icon ? (
        <div className="flex justify-center text-center mt-[64px]">{icon}</div>
      ) : null}

      <h1
        className={
          icon
            ? `text-[32px] text-center font-bold mt-[16px] text-neutral-900`
            : `text-[32px] text-center font-bold mt-[128px] text-neutral-900`
        }
      >
        {title}
      </h1>

      <div className="mt-[16px]">
        {subtitle1 ? (
          <p className="font-normal text-[14px] text-center text-neutral-600">
            {subtitle1}
          </p>
        ) : null}
      </div>
    </div>
  );
}
